<template>
  <v-container
    v-if="!$apollo.loading"
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      wrap
      justify-center
    >
      <v-flex
        xs12
        pack-title
      >
        <center>
          <h3>
            {{ $t('packs.chooseRightPack') }}
          </h3>
          <br>
          <span style="display: inline-flex;">
           
            <small :class="!annual ? 'bold' : ''">{{ $t('packs.monthly') }} </small>
            <v-switch
              v-model="annual"
              style="margin-top:-7px;"
              class="ml-6 mr-3"
              inset
              flat
            />
            <small :class="annual ? 'bold' : ''">{{ $t('packs.annual') }}  </small> 
           
          </span>
          <p
            class="bold"
          >
            {{ annual ? $t('packs.discount', { ptc: '18%' }) : $t('packs.noDiscount') }}
          </p>
        </center>
      </v-flex>
      <v-flex
        v-for="(product,i) in products"
        :key="i"
        xs12
        md3
      >
        <v-card
          class="pack-card"
          justify-center
          text-center
        >
          <div 
            class="text-center pack-header pl-8 pr-8 pt-5"
          >
            <h3>{{ product.name }}</h3>
            <center>
              <h2 v-if="product.system_name == 'Qualified'">
                Free
              </h2>
              <h2
                v-else
                class="text-success"
              >
                <sup>{{ product.currency | renderSymbol }}</sup>{{ (annual ? product.price_annual : product.price_monthly) | splitPrice }}<sup>{{ (annual ? product.price_annual : product.price_monthly) | splitPrice('cents') }}</sup>
              </h2>
              <div v-if="product.system_name == 'Qualified'">
                <span>{{ $t('packs.qualifiedOnly') }}</span>
                <v-tooltip
                  top
                  min-width="300px"
                >
                  <template v-slot:activator="{ on }">
                    <v-icon
                      class="tooltip"
                      v-on="on"
                    >
                      mdi-information-outline
                    </v-icon>
                  </template>
                  {{ $t('packs.qualifedIs') }}
                </v-tooltip>
              </div>
              <div v-else>
                <span>{{ $t('packs.mo') }}</span><br>
                <span v-if="annual">{{ $t('packs.paidAn') }}</span>
                <span v-else>{{ $t('packs.paidMo') }}</span>
              </div>
            </center>
            <v-btn
              class="success mt-5 mb-5"  
              block 
              :loading="loading"
              :disabled="activePlan(product.id)"
              @click="createOrder(product.id)"
            >
              {{ activePlan(product.id) ? $t('packs.active') : $t('packs.chooseButton') }}
            </v-btn> 
          </div>
        
          <v-flex>
            <ul>
              <li>
                <v-icon
                  v-if="!product.config.linkings"
                >
                  mdi-infinity
                </v-icon>
                <b>{{ product.config.linkings ? product.config.linkings : $t('packs.unlimited') }}</b> {{ $t('packs.connections') }}
              </li>
              <li>
                <v-icon
                  v-if="!product.config.linkings"
                >
                  mdi-infinity
                </v-icon><b>{{ product.config.exchanges ? product.config.exchanges : $t('packs.unlimited') }}</b> {{ $t('packs.exchanges') }}
              </li>
              <li>
                <v-icon
                  class="text-positive"
                >
                  mdi-check
                </v-icon>
                
                {{ $t('packs.estimator') }}
              </li>

              <li>
                <v-icon
                  class="text-positive"
                >
                  mdi-check
                </v-icon>
                
                {{ $t('packs.copyTrading') }}
              </li>
              <li>
                <v-icon
                  class="text-positive"
                >
                  mdi-check
                </v-icon>
                
                {{ $t('packs.riksManagement') }}
              </li>
              <li>
                <v-icon
                  v-if="product.config.risk_management"
                  class="text-positive"
                >
                  mdi-check
                </v-icon>
                <v-icon
                  v-else
                  class="text-negative"
                >
                  mdi-close
                </v-icon>
                {{ $t('packs.configTrading') }}
                <v-tooltip
                  top
                  min-width="300px"
                >
                  <template v-slot:activator="{ on }">
                    <v-icon
                      class="tooltip"
                      v-on="on"
                    >
                      mdi-information-outline
                    </v-icon>
                  </template>
                  {{ $t('packs.configTradingTooltip') }}
                </v-tooltip>
              </li>
            </ul>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
    <process
      ref="process"
      :invoice-id="invoiceId"
    />
  </v-container> 
</template>

<script>

import CREATE_ORDER_MUTATION from '@/graphql/mutations/CreateOrder.gql';
import PRODUCTS_QUERY from '@/graphql/queries/Products.gql';
import SERVICES_QUERY from '@/graphql/queries/Services.gql';

import { mapMutations } from "vuex";
import store from "@/store";
import Process from '@/views/Gateway/Process.vue'

export default {
  name: 'Subscription',
  components: {
    Process
  },
  data() {
    return {
      invoiceId: null,
      annual: true,
      selectedPlan: null,
      loading: false,
      selectedProducts: [],
      cards: ['Qualified', 'Starter', 'Pro']
    }
  },
  computed: {
    starterPrice() {
      return this.annual ? this.starter.price_annual : this.starter.price_monthly
    },
    proPrice() {
      return this.annual ? this.starter.price_annual : this.starter.price_monthly
    }
  },
  methods: {
    ...mapMutations("user", ["updateUser"]),
    activePlan(id) {
      let services = this.services
      let active = false
      if (!services || services.length == 0) {
        return false
      }
      services.forEach((service)=> {
        if (service.product_id == id) {
          active = true
          return
        }
      })
      return active
    },
    createOrder(id) {
      let products = []
      products.push(parseInt(id))

      this.loading = true
      this.$apollo.mutate({
          mutation: CREATE_ORDER_MUTATION,
          variables: {
            product_ids: products,
            billing_cycle: this.annual ? "annual": "monthly"
          }       
      }).then(data => {       
          this.invoiceId = data.data.createOrder.invoice ? data.data.createOrder.invoice.id : null
          this.loading = false
          if (!this.invoiceId) {
            this.updateUser();
            store.commit("app/setNotifier", this.$t('packs.planActivated'));
            return
          }
          this.$refs.process.open()
          
      }).catch(error => {
          this.loading = false; 
          this.errorHandler(error) 
      })
    }
  },
  apollo: {
    services: {
      query: SERVICES_QUERY,
    },
    products: {
      query: PRODUCTS_QUERY,
      result(data) {
        if (data.loading == false) {
          this.products.forEach(item => {
            this[item.system_name.toLowerCase()] = item
          });
        }
      },
    }
  }
}
</script>
<style lang="scss" scoped>
  .pack-title {
    .bold {
      font-weight: 700;
    }
  }
  .pack-card {
     .pack-header {
      width:100%;
      height:100px;
      display:table;
      .v-icon {
        margin-top: -3px;
        margin-left:4px;
        font-size:18px;
      }
      h2 {
        font-weight: 600!important;
        font-size:46px!important;
        sup {
          font-size:24px;
        }
      }
      h3 {
        font-weight: 600!important;
        font-size:22px!important;
      }
    }
    padding: 0;
    font-size:15px;
    ul {
      list-style-type: none;
      padding-left: 0px;
      margin: 10px 0 10px;
      li {
        border-bottom: 1px solid rgba(0,0,0,.12);
        padding: 10px 0 10px;
        font-size:14px;
        b {
          padding-left:7px;
          padding-right:5px;
        }
        .v-icon {
          font-size:16px!important;
        }
      }
    }
   
    .v-image {
      margin: 5px 0 20px;
    }
    h4 {
      text-align: center;
      font-size: 22px!important;
      font-weight: 700!important;
      margin:0!important;
    }
    span {
      font-size: 13px;
      font-weight: 600;
      color: #7f97ab;
      text-transform: uppercase;
    }
    p {
      margin-top:10px;
      max-width:250px;
    }
  }
</style>
